import DataTable, { TableProps } from "react-data-table-component";
// import "../../../styles/style.scss";
import "./table-mui.scss";

interface Props<T> {
  // setQueryParams: any;
  // queryParams: any;
  table: TableProps<T>;
  // paginationServer?: boolean;
  // noDataComponent?: string;
  // onRowClicked?: any;
  // sortServer?: boolean;
}

// const SORT_DIRECTION_MODE = {
//   ASC: 1,
//   DESC: -1,
// };
export function TableMui<T>(table: Props<T>) {
  const {
    // queryParams,
    // setQueryParams,
    // paginationServer = true,
    // sortServer = true,
    table: props,
  } = table;

  // const handlePageChange = (page: number) => {
  //   // Update pageNumber
  //   const newQueryParams = {
  //     ...queryParams,
  //     page,
  //   };
  //   if (!isEqual(queryParams, newQueryParams)) {
  //     setQueryParams(newQueryParams);
  //   }
  // };

  // const handleSort = (
  //   selectedColumn: TableColumn<any>,
  //   sortDirection: SortOrder
  // ) => {
  //   // If there are no columns to sort, nothing is done. Case when it is the first rendering
  //   if (!selectedColumn?.sortField) return;
  //   const newQueryParams = {
  //     ...queryParams,
  //     sortDirection:
  //       sortDirection === "asc"
  //         ? SORT_DIRECTION_MODE.ASC
  //         : SORT_DIRECTION_MODE.DESC,
  //     sortColumn: selectedColumn.sortField ? selectedColumn.sortField : "id",
  //   };
  //   if (!isEqual(queryParams, newQueryParams)) {
  //     setQueryParams(newQueryParams);
  //   }
  // };
  // const handlePerRowsChange = (newPerPage: number, page: number) => {
  //   // If pageNumber is equal to the current one, nothing is done. Case when it is the first rendering
  //   if (newPerPage === queryParams?.pageSize) return;
  //   // Update pageSize
  //   const newQueryParams = {
  //     ...queryParams,
  //     page: 1,
  //     pageSize: newPerPage,
  //   };
  //   if (!isEqual(queryParams, newQueryParams)) {
  //     setQueryParams(newQueryParams);
  //   }
  // };
  return (
    <DataTable
      columns={props.columns}
      data={props.data}
      // pagination
      // paginationComponent={(props: PaginationComponentProps) => (
      //   <Pagination {...props} />
      // )}
      // paginationServer={paginationServer}
      // paginationTotalRows={props.paginationTotalRows}
      // onChangePage={handlePageChange}
      noDataComponent={props.noDataComponent}
      // paginationPerPage={queryParams.pageSize ? queryParams.pageSize : 15}
      // paginationDefaultPage={queryParams.page ? queryParams.page : 1}
      // onChangeRowsPerPage={handlePerRowsChange}
      onRowClicked={props.onRowClicked}
      highlightOnHover={props.highlightOnHover}
      pointerOnHover={props.pointerOnHover}
      // onSort={handleSort}
      // sortServer={sortServer}
      // sortIcon={<ExpandMoreRounded sx={{ ml: 1 }} />}
      // defaultSortAsc={queryParams.sortDirection === SORT_DIRECTION_MODE.ASC}
      // defaultSortFieldId={
      //   queryParams?.sortColumn ? queryParams?.sortColumn : undefined
      // }
      fixedHeader={props?.fixedHeader}
      fixedHeaderScrollHeight={props?.fixedHeaderScrollHeight}
      customStyles={props.customStyles}
      // selectableRows={props?.selectableRows}
      // selectableRowsVisibleOnly={props?.selectableRowsVisibleOnly}
      // onRowMouseEnter={props?.onRowMouseEnter}
      // onRowMouseLeave={props?.onRowMouseLeave}
      // selectableRowSelected={props?.selectableRowSelected}
      // onSelectedRowsChange={props?.onSelectedRowsChange}
      // conditionalRowStyles={props?.conditionalRowStyles}
    />
  );
}

export default TableMui;
